import {createContext} from "react";

//types
import { itemListData } from "../../../../../../../common/TableData";

interface IReviewAndPayContext {
  selectedRows: itemListData[],
  rows : itemListData[],
  setRows : React.Dispatch<React.SetStateAction<itemListData[]>>;
  addSelectedRow: (data: itemListData) => void;
  setSelectedRows: (data: itemListData[]) => void;
}

export const ReviewAndPayContext = createContext<IReviewAndPayContext>({
  selectedRows: [],
  rows: [],
  setRows: () => {},
  addSelectedRow: () => {},
  setSelectedRows: () => {},
});
